import * as React from 'react';
import { limuirsComponent } from 'limuirs-components';
import _ from 'lodash';
import { nodeType } from '../../../types';

/**
 * Topic count for a node.
 *
 * @author Patricio Poratto, Adam Ayres
 */
const NodeTopicCount = ({ node, text }) =>
  _.has(node, 'topics.count') && (
    <div className="lia-node-topic-count">
      <i className="lia-fa lia-fa-comment-o" />
      {text.format('count', { count: node.topics.count })}
    </div>
  );

NodeTopicCount.propTypes = {
  /** The node to display the topic count of. (node.topics.count) */
  node: nodeType.isRequired
};

export default limuirsComponent(module, NodeTopicCount);
